import moment from 'moment';

export function minDate(date) {
    return (value) => {
        return moment(value).isSameOrAfter(date);
    }
}

export function maxDate(date) {
    return (value) => {
        return moment(value).isSameOrBefore(date);
    }
}
